document.addEventListener('DOMContentLoaded', () => {
  const selectVenueInForms = () => {
    const venue = get_venue();
    document.querySelectorAll('.venue-picker select').forEach((select) => {
      select.value = venue;
    });
  }

  selectVenueInForms();
  document.body.addEventListener('venueChanged', selectVenueInForms);
  document.addEventListener('gform_post_render', selectVenueInForms);

  document.querySelectorAll('.newsletter-cta-button').forEach((button) => {
    const section = button.closest('section');
    
    button.addEventListener('click', (e) => {
      e.preventDefault();

      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  });
});